import { render, staticRenderFns } from "./SelectorGrupoOrigem.vue?vue&type=template&id=7a61a3e2&scoped=true"
import script from "./SelectorGrupoOrigem.vue?vue&type=script&lang=js"
export * from "./SelectorGrupoOrigem.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/vendor/libs/vue-multiselect/vue-multiselect.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a61a3e2",
  null
  
)

export default component.exports